import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../api-routes";
import apiService from "../../services/service";

const initialState = {
  directorsData: null,
  status: "idle",
  error: null,
};

export const directorAppointment = createAsyncThunk(
  "directors/postAppointment",
  async ({ id, data }) => {
    const url = API_ROUTES.ADD_DIRECTOR(id);
    return await apiService(url, "POST", { body: JSON.stringify(data) });
  },
);

export const updateDirectorAppointment = createAsyncThunk(
  "directors/updateAppointment",
  async ({ id, data }) => {
    const url = API_ROUTES.UPDATE_DIRECTOR(id);

    const response = await apiService(url, "PUT", {
      body: JSON.stringify(data),
    });
    return response.data;
  },
);

export const fetchDirectors = createAsyncThunk(
  "directors/fetchDirectors",
  async (arg) => {
    // Support both old signature (id string) and new signature ({ id, skipCache })
    const id = typeof arg === "object" ? arg.id : arg;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    return await apiService(API_ROUTES.FETCH_DIRECTORS, "GET", {
      replace: { id },
      skipCache,
    });
  },
);

const directorsSlice = createSlice({
  name: "directors",
  initialState,
  reducers: {
    resetDirectorsData: (state) => {
      state.status = "idle";
      state.directorsData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(directorAppointment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(directorAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.directorsData = action.payload;
      })
      .addCase(directorAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateDirectorAppointment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateDirectorAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (state.directorsData) {
          state.directorsData = state.directorsData.map((director) =>
            director.id === action.payload.id ? action.payload : director,
          );
        } else {
          state.directorsData = [action.payload];
        }
      })
      .addCase(updateDirectorAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchDirectors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDirectors.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.directorsData = action.payload.data || action.payload;
      })
      .addCase(fetchDirectors.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetDirectorsData } = directorsSlice.actions;
export default directorsSlice.reducer;
